import { Directive, ElementRef, HostListener, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pghMaxLength]',
    standalone: true
})
export class MaxLengthDirective {
  constructor(
    private elementRef: ElementRef,
    private ngControl: NgControl
  ) {
    this._nativeRef = this.elementRef.nativeElement;
  }

  private _nativeRef: HTMLInputElement;
  readonly maxLength = input<number>(undefined, { alias: "pghMaxLength" });

  @HostListener('input', ['$event.target.value'])
  onInputChange(value) {
    const maxLength = this.maxLength();
    if (maxLength) {
      this.ngControl.control.setValue(value.slice(0, maxLength));
      this._nativeRef.value = value.slice(0, maxLength);
    }
  }
}
